/* Country gate: sends Australian and New Zealand visitors to their own store, offers UK and other visitors their store, and tells everyone else (on the AU/NZ stores)
   that those stores ship to Australia and New Zealand only. The visitor's country comes from Cloudflare's own
   /cdn-cgi/trace on this domain (no app, no third-party call). A visitor's choice is remembered for 30 days. */
(() => {
  const d = document.currentScript.dataset;
  const here = d.site;
  const hosts = { AU: d.au, NZ: d.nz, UK: d.uk, CA: d.ca, INTL: d.intl };
  const names = { AU: 'the Australian', NZ: 'the New Zealand', UK: 'the UK', CA: 'the Canadian', INTL: 'the international' };
  const DAYS_30 = 30 * 864e5;
  const chosen = () => { try { return Date.now() - Number(localStorage.getItem('re-site-choice')) < DAYS_30; } catch (e) { return false; } };
  const markChosen = () => { try { localStorage.setItem('re-site-choice', Date.now()); } catch (e) { /* private mode */ } };
  const urlFor = (site, stay) => {
    const u = new URL(location.href); u.host = hosts[site]; if (stay) u.searchParams.set('stay', '1'); return u.href;
  };

  if (/bot|crawl|spider|slurp|lighthouse|pagespeed|facebookexternalhit|preview/i.test(navigator.userAgent)) return;
  if (new URLSearchParams(location.search).has('stay')) { markChosen(); return; }
  if (chosen()) return;

  fetch('/cdn-cgi/trace', { cache: 'no-store' })
    .then((r) => r.text())
    .then((t) => {
      const country = (t.match(/^loc=([A-Z]{2})$/m) || [])[1];
      if (!country || country === 'XX' || country === 'T1') return;
      const target = country === 'AU' || country === 'NZ' ? country : country === 'GB' ? 'UK' : country === 'CA' ? 'CA' : 'INTL';
      if (target === here) return;
      if (target === 'AU' || target === 'NZ') {
        if (!/^\/(cart|checkout)/.test(location.pathname)) location.replace(urlFor(target));
        return;
      }
      banner(country, target);
    })
    .catch(() => {});

  function banner(country, target) {
    let place = country;
    try { place = new Intl.DisplayNames(['en'], { type: 'region' }).of(country) || country; } catch (e) { /* keep the code */ }
    const intlLive = d.intlLive === 'true';
    const style = document.createElement('style');
    style.textContent = `.re-gate { position: fixed; z-index: 100000; top: 12px; left: 50%; translate: -50% 0; width: min(520px, calc(100vw - 24px)); box-sizing: border-box; padding: 16px 18px; border: 1.5px solid var(--style-line, #f7d4e1); border-radius: 18px; background: #fff; color: var(--style-ink, #3d1230); box-shadow: 0 18px 40px -18px color-mix(in srgb, var(--style-button, #c2336f) 55%, transparent); font-size: 14px; line-height: 1.45; animation: re-gate-in .3s ease-out; }
.re-gate p { margin: 0 0 12px; }
.re-gate div { display: flex; flex-wrap: wrap; gap: 8px; }
.re-gate__go, .re-gate__stay { display: inline-block; padding: 9px 16px; border: 1.5px solid var(--style-button, #c2336f); border-radius: 999px; font: inherit; font-weight: 600; text-decoration: none; cursor: pointer; }
.re-gate__go { background: var(--style-button, #c2336f); color: #fff; }
.re-gate__stay { background: #fff; color: var(--style-button, #c2336f); }
@keyframes re-gate-in { from { opacity: 0; translate: -50% -8px; } }
@media (prefers-reduced-motion: reduce) { .re-gate { animation: none; } }`;
    document.head.append(style);
    const box = document.createElement('div');
    box.className = 're-gate'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Choose your store');
    const text = document.createElement('p');
    const fill = (tpl, vars) => tpl.replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
    const vars = { place, here: here === 'AU' ? 'our Australian' : 'our New Zealand', target: { UK: 'UK', CA: 'Canadian' }[target] || 'international' };
    text.textContent = fill(d.msg, vars);
    const row = document.createElement('div');
    const add = (label, cls, fn) => { const b = document.createElement(fn ? 'button' : 'a'); b.className = cls; b.textContent = label; if (fn) { b.type = 'button'; b.onclick = fn; } row.append(b); return b; };
    const close = () => { markChosen(); box.remove(); };
    if (intlLive) {
      const a = add(fill(d.go, vars), 're-gate__go'); a.href = urlFor(target, true);
      add(fill(d.stay, { ...vars, here: names[here] }), 're-gate__stay', close);
    } else {
      add('Got it', 're-gate__go', close);
    }
    box.append(text, row);
    document.body.append(box);
  }
})();
